import React from "react";
import { Spinner } from "react-bootstrap";

interface IconSpinnerProps {
  centered?: boolean;
  size?: string;
  type?: string;
}

const IconSpinner = ({
  centered,
  size = "lg",
  type = "info",
}: IconSpinnerProps) => {
  const spinner = (
    <Spinner
      animation="border"
      role="status"
      data-testid="loading-spinner"
      // react-bootstrap only declares "sm", but "lg" has always been passed
      // through to the spinner-border-lg class — keep the wire format
      size={size as "sm"}
      variant={type}
    >
      <span className="visually-hidden">Loading...</span>
    </Spinner>
  );
  if (centered) {
    return <div className="center">{spinner}</div>;
  }

  return spinner;
};

export default IconSpinner;
